import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Container, Card, Button } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import DepartmentTopbar from "../SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "../SuperAdmin/components/DepertmentSidebar";


function TradeLicenseHistory() {
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [tradeInfo, setTradeInfo] = useState({
    trade_name: "",
    trade_owner: "",
  });
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchHistory = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_URL}list-payment-history-by tradeid.php?trade_license_id=${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success && Array.isArray(response.data.data)) {
          setHistory(response.data.data);
          // Set trade name and owner from the first history record
          if (response.data.data.length > 0) {
            setTradeInfo({
              trade_name: response.data.data[0].trade_name,
              trade_owner: response.data.data[0].trade_owner,
            });
          }
        } else {
          setHistory([]);
          toast.info(
            response.data.message || "No history found for this license."
          );
        }
      } catch (error) {
        toast.error("Failed to fetch payment history.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchHistory();
    }
  }, [id, API_URL, token]);

  const columns = [
    {
      name: "Transaction Type",
      selector: (row) => row.type,
      sortable: true,
      cell: (row) => (
        <span
          className={`text-capitalize badge bg-${
            row.type === "register" ? "primary" : "info"
          }`}
        >
          {row.type}
        </span>
      ),
    },
    { name: "Reg. No.", selector: (row) => row.reg_no, sortable: true },
    {
      name: "Bill No.",
      selector: (row) => row.bill_no || "N/A",
      sortable: true,
    },
    {
      name: "Amount (₹)",
      selector: (row) => parseFloat(row.amount).toLocaleString(),
      sortable: true,
    },
    {
      name: "Validity",
      selector: (row) => row.validity_peroid,
      sortable: true,
    },
    { name: "Payment Date", selector: (row) => row.reg_date, sortable: true },
    { name: "Expire Date", selector: (row) => row.expire_date, sortable: true },
    {
      name: "Transaction Time",
      selector: (row) => row.created_at,
      sortable: true,
    },
  ];

  return (
    <>
      <DepartmentTopbar />
      <div className="d-flex">
        <DepartmentSidebar />
        <Container fluid className="p-4 bg-light">
          <Card className="shadow-sm">
            <Card.Header
              as="h5"
              style={{
                backgroundColor: "#e3f2fd",
                borderBottom: "2px solid #1976d2",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span style={{ color: "#1976d2" }}>Payment History</span>
                  {tradeInfo.trade_name && (
                    <div className="h6 mb-0 mt-1">
                      {tradeInfo.trade_name} ({tradeInfo.trade_owner})
                    </div>
                  )}
                </div>
                <Link to="/departmentDashboard/trade-license-list">
                  <Button variant="secondary" size="sm">
                    Back to List
                  </Button>
                </Link>
              </div>
            </Card.Header>
            <Card.Body>
              <DataTable
                columns={columns}
                data={history}
                progressPending={loading}
                pagination
                responsive
                highlightOnHover
              />
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default TradeLicenseHistory;
